import request from '@/utils/request'

let HquesApi = {

  /*问卷列表*/
  list(data) {
    return request._post('/shop/plus.hques.Index/index', data);
},
/*添加问卷*/
add(data) {
    return request._post('/shop/plus.hques.Index/add', data);
},
/*修改问卷*/
edit(data) {
    return request._post('/shop/plus.hques.Index/edit', data);
},
/*删除问卷*/
del(data) {
    return request._post('/shop/plus.hques.Index/del', data);
},
copy(data) {
    return request._post('/shop/plus.hques.Index/copy', data);
},
/*问卷详情*/
detail(data) {
  return request._post('/shop/plus.hques.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hques.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hques.Setting/getSetting', data, errorback);
    },
      /*修改部分数据*/
editPart(data) {
    return request._post('/shop/plus.hques.Index/editPart', data);
},
/*获取医生*/
getDoctor(data) {
    return request._post('/shop/plus.hques.Index/getDoctor', data);
  },
}
export default HquesApi;



// WEBPACK FOOTER //
// ./src/api/hques.js